let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page766_game2/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page766_game2/audio/79_pizza.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game2/img/audioOn.png', iconOff: 'games/page766_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 900,
        x: 1115,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game2/audio/80_cheese.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game2/img/audioOn.png', iconOff: 'games/page766_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 780,
        x: 1465,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game2/audio/81_tomato sauce.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game2/img/audioOn.png', iconOff: 'games/page766_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 620,
        x: 475,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game2/audio/82_ham.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game2/img/audioOn.png', iconOff: 'games/page766_game2/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 530,
        x: 1205,
      },
      unit: 'px',
    },
  ],
};

export default elements;
